import React from 'react';
import { useLocation } from 'react-router-dom';
import { styled } from '@linaria/react';
import { toggle } from 'opticks';
import { Button } from '@daedalus/atlas/Button';
import { Icon } from '@daedalus/atlas/Icon';
import { isApple } from '@daedalus/core/src/_web/utils/userAgent';
import { AuthenticationMethod } from '@daedalus/core/src/auth/types/Auth';
import { AuthenticationProvider } from '@daedalus/core/src/auth/types/Cognito';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { HandleLogin, SusiHistoryState } from '../types';
const ButtonsWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonsWrapper",
  class: "b180ti5k",
  propsAsIs: false
});
interface Props {
  handleLogin: HandleLogin;
  handleEmailLogin?: (e: React.SyntheticEvent) => void;
}
export const SignInButtons = ({
  handleLogin,
  handleEmailLogin
}: Props) => {
  const location = useLocation<{
    susi: SusiHistoryState;
  }>();
  const analyticsData = location.state?.susi?.analyticsData;
  const isAppleDevice = isApple();
  return <ButtonsWrapper>
      {isAppleDevice && <Button fullWidth dataId="SocialLoginApple" size="xl" iconStart={<Icon name="Apple" />} variant="secondary" onClick={handleLogin(AuthenticationMethod.Apple, AuthenticationProvider.Apple, analyticsData)}>
          <FormattedMessageWrapper id="SUSI.continueWith" defaultMessage="Continue with {channel}" values={{
        channel: 'Apple'
      }} />
        </Button>}

      <Button fullWidth variant="secondary" dataId="SocialLoginGoogle" size="xl" iconStart={<Icon name="GoogleColor" />} onClick={handleLogin(AuthenticationMethod.Google, AuthenticationProvider.Google, analyticsData)}>
        <FormattedMessageWrapper id="SUSI.continueWith" defaultMessage="Continue with {channel}" values={{
        channel: 'Google'
      }} />
      </Button>

      <Button fullWidth variant="secondary" dataId="SocialLoginFacebook" size="xl" iconStart={<Icon name="FacebookColor" />} onClick={handleLogin(AuthenticationMethod.Facebook, AuthenticationProvider.Facebook, analyticsData)}>
        <FormattedMessageWrapper id="SUSI.continueWith" defaultMessage="Continue with {channel}" values={{
        channel: 'Facebook'
      }} />
      </Button>
      {toggle('367a6300-email-otp-signup', false, <Button fullWidth variant="secondary" dataId="SocialLoginEmail" size="xl" iconStart={<Icon name="Mail" />} onClick={handleEmailLogin}>
          <FormattedMessageWrapper id="SUSI.continueWith" defaultMessage="Continue with {channel}" values={{
        channel: 'Email'
      }} />
        </Button>)}
    </ButtonsWrapper>;
};

require("./SignInButtons.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SignInButtons.tsx");